import { IGetState } from '../../../types/types';
import { Dispatch, ThunkAction } from '../../../types/actions';
import { authUserSetFirstTemplateBoard } from '../authUser/authUserSetFirstTemplateBoard';

export const IGNORE_FIRST_TEMPLATE_RESET_SESSIONSTORAGE = 'IGNORE_FIRST_TEMPLATE_RESET_SESSIONSTORAGE';

export const boardResetFirstTemplateIfNeeded = (): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        let isIgnore = sessionStorage.getItem(IGNORE_FIRST_TEMPLATE_RESET_SESSIONSTORAGE);
        isIgnore = isIgnore ? JSON.parse(isIgnore) : false;
        if (isIgnore) {
            sessionStorage.setItem(IGNORE_FIRST_TEMPLATE_RESET_SESSIONSTORAGE, JSON.stringify(false));
            return;
        }
        dispatch(authUserSetFirstTemplateBoard(null));
    };
    return action;
};
